
import { defineComponent, PropType } from "vue";
export default defineComponent({
  name: "AppFilterInput",
  props: {
    relatedSearch: {
      type: Array as PropType<string[]>,
    },
    Kw: {
      type: String,
      default: "",
    },
    Dg: {
      type: String,
      default: "",
    },
    Gb: {
      type: String,
      default: "",
    },
    Kj: {
      type: String,
      default: "",
    },
  },
  data() {
    return {
      isWordSOpen: false,
      wordRelated: "",
    };
  },
  methods: {
    onClickRelatedWordsSet(word: string) {
      this.wordRelated = word;
      const KwText: HTMLInputElement = <HTMLInputElement>document.getElementById("js-RelatedWords");
      const KwText2: HTMLInputElement = <HTMLInputElement>document.getElementsByName("Kw")[0];
      if (KwText) KwText.value = word;
      if (KwText2) KwText2.value = word;
    },
    // 全角英数記号半角変換
    abc123ToHAN(strVal: string): string {
      var han = strVal.replace(/[！-～]/g, function (s) {
        return String.fromCharCode(s.charCodeAt(0) - 0xfee0);
      });
      // 文字コードシフトで対応できない文字の変換
      return han
        .replace(/”/g, '"')
        .replace(/’/g, "'")
        .replace(/‘/g, "`")
        .replace(/￥/g, "\\")
        .replace(/〜/g, "~")
        .replace(/\u3000/g, " ");
    },
  },
  mounted() {
    /**
     * 関連ワードを全て表示・一行表示
     * 一行表示のクラス.-OneLinerをトグルする
     */
    const relatedSearch: HTMLDivElement = <HTMLDivElement>document.getElementById("js-relatedSearch");
    const oneLiner: HTMLDivElement = <HTMLDivElement>document.getElementById("js-relatedWords");
    const wordsToggleOpen: HTMLDivElement = <HTMLDivElement>document.getElementById("js-wordsToggleOpen");
    const wordsToggleClose: HTMLDivElement = <HTMLDivElement>document.getElementById("js-wordsToggleClose");
    if (oneLiner) {
      wordsToggleOpen.addEventListener("click", () => {
        relatedSearch.classList.add("js-inline");
        oneLiner.classList.remove("-OneLiner");
        wordsToggleOpen.classList.add("js-hidden");
        wordsToggleClose.classList.add("js-block");
      });
      wordsToggleClose.addEventListener("click", () => {
        relatedSearch.classList.remove("js-inline");
        oneLiner.classList.add("-OneLiner");
        wordsToggleOpen.classList.remove("js-hidden");
        wordsToggleClose.classList.remove("js-block");
      });
    }
    /**
     *
     *
     */
    const accordionToggle = document.getElementById("js-toggle");
    const maxWidth = 526;
    if (accordionToggle) {
      accordionToggle.addEventListener("click", () => {
        if (oneLiner.clientWidth < maxWidth) {
          wordsToggleOpen.classList.add("js-hidden");
        }
        // console.log(oneLiner.clientWidth);
      });
    }
    /**
     *
     *
     */
    // let RelatedWords:HTMLInputElement = document.getElementById('js-RelatedWords') as HTMLInputElement;
    // RelatedWords.value = this.wordRelated;

    // mounted終わり
  },
});
